<template>
  <div>
    <!--begin::Head-->
    <!-- <div class="kt-login__head">
      <span class="kt-login__signup-label">Already have an account?</span
      >&nbsp;&nbsp;
      <router-link class="kt-link kt-login__signup-link" :to="{ name: 'login' }"
        >Login!</router-link
      >
    </div> -->
    <!--end::Head-->

    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <!--begin::Form-->
        <b-form
          class="kt-form form elevation-1"
          @submit.stop.prevent="onSubmit"
        >
          <div class="heading">
            <h2 class="form-heading">PAYNOWPRO</h2>
            <p>Sign Up</p>
          </div>

          <b-form-group
            class="form-group"
            id="example-input-group-0"
            label
            label-for="example-input-0"
            ><label class="d1-block">Full Name</label>
            <b-form-input
              class="input"
              id="example-input-0"
              name="example-input-0"
              v-model="$v.form.name.$model"
              :state="validateState('name')"
              aria-describedby="input-0-live-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="input-0-live-feedback"
              >Name is required.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            class="form-group"
            id="example-input-group-1"
            label
            label-for="example-input-1"
            ><label class="d1-block">Email Address</label>
            <b-form-input
              class="input"
              id="example-input-1"
              name="example-input-1"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="input-1-live-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="input-1-live-feedback"
              >Email is required and a valid email
              address.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            class="form-group"
            id="example-input-group-2"
            label
            label-for="example-input-2"
            ><label class="d1-block">Password</label>
            <b-form-input
              class="input"
              type="password"
              id="example-input-2"
              name="example-input-2"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="input-2-live-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="input-2-live-feedback"
              >Password is required.</b-form-invalid-feedback
            >
          </b-form-group>

          <!--begin::Action-->
          <div class="kt-login__actions">
            <!-- <b-button
              v-on:click="$router.push('login')"
              class="btn btn-secondary btn-elevate kt-login__btn-primary"
              >{{ $t("AUTH.GENERAL.BACK_BUTTON") }}</b-button
            > -->

            <b-button
              type="submit"
              class="btn btn-auth login-btn-auth btn-primary btn-elevate kt-login__btn-primary kt-spinner--light kt-spinner--right"
              >{{ $t("AUTH.REGISTER.TITLE") }}</b-button
            >
          </div>
          <span class="kt-login__signup-label">Already have an account?</span
          >&nbsp;&nbsp;
          <router-link
            class="kt-link kt-login__signup-link login-link"
            :to="{ name: 'login' }"
            >Login!</router-link
          >
          <!--end::Action-->
        </b-form>
        <!--end::Form-->

        <!--begin::Divider-->
        <div class="kt-login__divider">
          <div class="kt-divider">
            <span></span>
            <span>CONFIRM ACCOUNT</span>
            <span></span>
          </div>
        </div>
        <!--end::Divider-->

        <!--begin::Options-->
        <b-form
          class="kt-form form elevation-1"
          @submit.stop.prevent="onConfirm"
        >
          <b-form-group
            class="form-group"
            id="example-input-group-1"
            label=""
            label-for="example-input-1"
            ><label class="d1-block">Email Address</label>
            <b-form-input
              class="input"
              id="example-input-1"
              name="example-input-1"
              v-model="$v.confirm.confirmEmail.$model"
              :state="validateState('confirmEmail')"
              aria-describedby="input-1-live-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="input-1-live-feedback"
              >Email is required and a valid email
              address.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group
            id="example-input-group-0"
            class="form-group"
            label=""
            label-for="example-input-0"
            ><label class="d1-block">Code</label>
            <b-form-input
              class="input"
              id="example-input-0"
              name="example-input-0"
              v-model="$v.confirm.code.$model"
              :state="validateState('code')"
              aria-describedby="input-0-live-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="input-0-live-feedback"
              >Code is required.</b-form-invalid-feedback
            >
          </b-form-group>

          <!--begin::Action-->
          <div class="kt-login__actions">
            <b-button
              type="submit"
              class="btn btn-auth btn-primary login-btn-auth btn-elevate kt-login__btn-primary kt-spinner--light kt-spinner--right"
              >Confirm Account</b-button
            >
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Options-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import "./auth.css";
import { mapState } from "vuex";
import { REGISTER } from "@/store/auth.module";
import { CONFIRM_USER } from "@/store/auth.module";
import { LOGOUT } from "@/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, required, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "register",
  data() {
    return {
      // Remove this dummy login info
      form: {
        name: null,
        email: null,
        password: null
      },
      confirm: {
        confirmEmail: null,
        code: null
      }
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    },
    confirm: {
      code: {
        required,
        minLength: minLength(6)
      },
      confirmEmail: {
        required,
        email
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name] ?? this.$v.confirm[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        username: null,
        email: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const username = this.$v.form.name.$model;
      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add("kt-spinner");

      // send register request
      this.$store
        .dispatch(REGISTER, {
          email: email,
          password: password,
          name: username
        })
        .then(() => {
          submitButton.classList.remove("kt-spinner");
          this.$router.push({ name: "dashboard" });
        });
    },
    onConfirm() {
      this.$v.confirm.$touch();
      if (this.$v.confirm.$anyError) {
        return;
      }

      const username = this.$v.confirm.confirmEmail.$model;
      const code = this.$v.confirm.code.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add("kt-spinner");

      // dummy delay
      // send register request
      this.$store
        .dispatch(CONFIRM_USER, {
          username,
          code
        })
        .then(() => {
          submitButton.classList.remove("kt-spinner");
          this.$router.push({ name: "login" });
        });
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    }
  }
};
</script>
